// extracted by mini-css-extract-plugin
export default {"topcontainer":"latestCurr_topcontainer__3UBrf","latestcontainer":"latestCurr_latestcontainer__unBVp"};